import axios from 'axios';
import yaml from 'js-yaml';

const CACHE = {};

const inProgress = {};
const ALLOWED_HOSTS=[
  "https://argon-dev-eu-west-1.gw.stratus-ps-rd.ops.hereapi.com/openapi",
  "https://argon-prd-eu-west-1.gw.stratus-ps-p.ops.hereapi.com/openapi",
  "https://argon-prd-ap-northeast-2.gw.stratus-ps-p.ops.hereapi.com/openapi"
]

// eslint-disable-next-line import/no-anonymous-default-export
export default function (url, customization, settings) {
  const options = { responseType: 'text' };
  if (customization) {
    url = `${url}?customizations=${customization}`;
    if (settings.type === 'apiKey') {
      url = `${url}&apiKey=${settings.apiKey}`;
    } else if (settings.type === 'platformCredential') {
      options.headers = {
        'AUthorization': `Bearer ${settings.token}`
      }
    }
  }

  if (inProgress[url]) {
    return inProgress[url];
  }
  const promise = new Promise((resolve, reject) => {
    if (CACHE[url]) {
      resolve(CACHE[url]);
      delete inProgress[url];
      return;
    }

    try {
      if (ALLOWED_HOSTS.includes(url)) {
        axios
          .get(url, options)
          .then((res) => {
            const { data } = res;
          const yamlData = yaml.load(data, { schema: yaml.FAILSAFE_SCHEMA });
          CACHE[url] = yamlData;
          resolve(yamlData);
          delete inProgress[url];
        })
        .catch((err) => {
          reject(err);
        });
      }
    } catch(e) {
    }
  });
  inProgress[url] = promise;

  return promise;
}
